import { NgModule, isDevMode } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';

import { RouteReuseStrategy } from '@angular/router';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';



import { IonicModule, IonicRouteStrategy } from '@ionic/angular';



import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';



import { IonicStorageModule } from '@ionic/storage-angular';

import { ServiceWorkerModule } from '@angular/service-worker';

import { OfflineCacheInterceptor } from './interceptors/offline-cache.interceptor';



@NgModule({

  declarations: [AppComponent],

  imports: [

    BrowserModule,

    IonicModule.forRoot(),

    AppRoutingModule,

    HttpClientModule,

    IonicStorageModule.forRoot(),

    ServiceWorkerModule.register('ngsw-worker.js', {

      enabled: !isDevMode(),

      registrationStrategy: 'registerWhenStable:30000'

    })

  ],

  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: OfflineCacheInterceptor, multi: true }
  ],

  bootstrap: [AppComponent],

})

export class AppModule {}